export type UserRole =
  | 'developer'
  | 'technical_lead'
  | 'developer_leader'
  | 'engineer_manager'
  | 'head_of_engineering'
  | 'cto'
  | 'product_manager'

export type Specialty = 'frontend' | 'backend' | 'fullstack'
export type EmployeeStatus = 'active' | 'retired'
export type ExitReason = 'company_decision' | 'resignation'

export interface User {
  id: string
  email: string
  githubUsername?: string
  name: string
  avatarUrl?: string
  role: UserRole
  leaderId?: string
  hireDate?: string
  personalFolderUrl?: string
  country?: string
  city?: string
  specialty?: Specialty
  tmdId?: string
  tmdName?: string
  subTmdId?: string
  subTmdName?: string
  hasPassport: boolean
  hasVisa: boolean
  status: EmployeeStatus
  exitReason?: ExitReason
  exitDate?: string
  currentLevelName?: string
  tlId?: string
  tlName?: string
  pmId?: string
  pmName?: string
  devLeaderId?: string
  devLeaderName?: string
  devLeaderRole?: string
  // Líder directo explícito (users.leader_id) — tiene prioridad sobre devLeaderName
  leaderName?: string
}

export interface Certification {
  id: string
  userId: string
  certification: string
  certifiedAt: string
}

export const ROLE_LABELS: Record<UserRole, string> = {
  developer:           'Developer',
  technical_lead:      'Technical Lead',
  developer_leader:    'Developer Leader',
  engineer_manager:    'Engineer Manager',
  head_of_engineering: 'Head of Engineering',
  cto:                 'CTO',
  product_manager:     'Product Manager',
}

export const SPECIALTY_LABELS: Record<Specialty, string> = {
  frontend:  'Frontend',
  backend:   'Backend',
  fullstack: 'Fullstack',
}

export const SALARY_ROLES: UserRole[] = [
  'developer_leader', 'engineer_manager', 'head_of_engineering', 'cto',
]

export function canSeeSalary(role: UserRole): boolean {
  return SALARY_ROLES.includes(role)
}

export const CPF_LEVEL_ROLES: UserRole[] = [
  'technical_lead', 'developer_leader', 'engineer_manager', 'head_of_engineering', 'cto',
]

export function canSeeCPFLevel(role: UserRole): boolean {
  return CPF_LEVEL_ROLES.includes(role)
}

export function tenureLabel(hireDate?: string): string {
  if (!hireDate) return '—'
  const months = Math.floor(
    (Date.now() - new Date(hireDate).getTime()) / (1000 * 60 * 60 * 24 * 30.44)
  )
  if (months < 12) return `${months}m`
  const years  = Math.floor(months / 12)
  const rem    = months % 12
  return rem > 0 ? `${years}a ${rem}m` : `${years}a`
}
